import React from 'react';

import { Link } from 'react-router-dom';
import classNames from 'classnames';
import { getHelpNodePath } from '@ergeon/help-components';

import Panel from '../Panel';
import { WIKI_SECTIONS } from '../sidebar/sections';

const TILE_CLASSES = classNames(
  'flex h-full items-center gap-3 rounded-lg p-3 hover:bg-gray-50 dark:hover:bg-gray-700',
  'focus:outline-hidden focus-visible:ring-2 focus-visible:ring-blue-500 dark:focus-visible:ring-blue-300',
);

const SectionGrid = () => (
  <Panel meta={`${WIKI_SECTIONS.length} sections`} title="Browse" titleId="wiki-browse-title">
    <ul className="grid grid-cols-1 gap-1 p-2 sm:grid-cols-2 xl:grid-cols-3">
      {WIKI_SECTIONS.map(({ icon: Icon, nodeKey, title }) => (
        <li key={nodeKey}>
          <Link className={TILE_CLASSES} to={getHelpNodePath(nodeKey)}>
            <span className="flex size-10 shrink-0 items-center justify-center rounded-lg bg-blue-50 dark:bg-blue-900">
              <Icon aria-hidden="true" className="size-5 shrink-0 text-blue-600 dark:text-blue-300" />
            </span>
            <span className="min-w-0 font-heading text-base font-semibold text-gray-900 dark:text-white">{title}</span>
          </Link>
        </li>
      ))}
    </ul>
  </Panel>
);

export default SectionGrid;
